import { render, staticRenderFns } from "./FIBYesNo.vue?vue&type=template&id=55fc089b&"
import script from "./FIBYesNo.vue?vue&type=script&lang=js&"
export * from "./FIBYesNo.vue?vue&type=script&lang=js&"
import style0 from "./FIBYesNo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QRadio});
